import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Text = styled.div`
  font-size: inherit;
  color: ${colors.strongGray};

  @media (max-width: 550px) {
    font-size: 12px;
  }
`
